import { createAction, props } from '@ngrx/store';
import { Observation } from '../../models/observation';

export const fetchObservations = createAction(
  '[Observations] Fetch Observations',
  props<{ assignment?: string; creator?: string; status?: string; living_thing?: string; event?: string; equipment?: string; recording_session?: string; page?: number; page_size?: number; ordering?: string }>()
);

export const fetchObservationsSuccess = createAction(
  '[Observations] Fetch Observations Success',
  props<{ observations: Observation[]; count: number }>()
);

export const fetchObservationsFail = createAction('[Observations] Fetch Observations Fail', props<{ error: string }>());

export const fetchObservation = createAction('[Observations] Fetch Observation', props<{ payload: string }>());

export const fetchObservationSuccess = createAction(
  '[Observations] Fetch Observation Success',
  props<{ observation: Observation }>()
);

export const fetchObservationFail = createAction('[Observations] Fetch Observation Fail', props<{ error: string }>());

export const addObservation = createAction('[Observations] Add Observation', props<{ payload: Observation }>());
export const addObservationSuccess = createAction(
  '[Observations] Add Observation Success',
  props<{ observation: Observation }>()
);
export const addObservationFail = createAction('[Observations] Add Observation Fail', props<{ error: string }>());

export const updateObservation = createAction(
  '[Observations] Update Observation',
  props<{ payload: { id: string; newObservation: Observation } }>()
);
export const updateObservationSuccess = createAction(
  '[Observations] Update Observation Success',
  props<{ payload: { id: string; newObservation: Observation } }>()
);
export const updateObservationFail = createAction('[Observations] Update Observation Fail', props<{ error: string }>());

export const deleteObservation = createAction('[Observations] Delete Observation', props<{ payload: string }>());

export const deleteObservationSuccess = createAction(
  '[Observations] Delete Observation Success',
  props<{ payload: string }>()
);

export const deleteObservationFail = createAction('[Observations] Delete Observation Fail', props<{ error: string }>());

export const startAddObservationWithMedia = createAction(
  '[Observations] Start Add Observation With Media',
  props<{ observation: Observation; audioFiles?: any[]; imageFiles?: File[]; videoFiles?: File[] }>()
);

export const startUpdateObservationWithMedia = createAction(
  '[Observations] Start Update Observation With Media',
  props<{ payload: { id: string; newObservation: Observation; audioFiles?: any[]; imageFiles?: File[]; videoFiles?: File[] } }>()
);

export const clearSelectedObservation = createAction('[Observations] Clear Selected Observation');
